import { Action } from '@ngrx/store';

import { mergeDeepRight } from 'ramda';

import { settings } from '@environment';

import { ACTIONS } from './constants';
import { StorageSyncOptions } from './interfaces';
import { rehydrateState } from './rehydrate-state';
import { saveState } from './save-state';

export const storageSync = <T>(options: StorageSyncOptions<T>) => {
  return (reducer: (state: T | undefined, action: Action) => T): ((state: T | undefined, action: Action) => T) => {
    let scope: string;

    if (document.defaultView.location.hostname !== 'localhost') {
      scope = document.defaultView.location.pathname.split('/')[1] ?? 'dev';
    } else {
      scope = 'dev';
    }

    const config: StorageSyncOptions<T> = {
      ...options,
      prefix: `${settings.prefix}-${scope}`,
    };

    const rehydratedState = rehydrateState(config);

    return (state: T | undefined, action: Action): T => {
      const nextState = action.type === ACTIONS.INIT_ACTION ? reducer(state, action) : ({ ...state } as T);
      const shouldMerge = rehydratedState !== undefined && (action.type === ACTIONS.INIT_ACTION || action.type === ACTIONS.UPDATE_ACTION);
      const mergedState = reducer(shouldMerge ? mergeDeepRight<any, any>(nextState, rehydratedState) : nextState, action);

      if (action.type !== ACTIONS.INIT_ACTION && action.type !== ACTIONS.INIT_ACTION_EFFECTS) {
        saveState(mergedState, config);
      }

      return mergedState;
    };
  };
};
